import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Underline = createReactComponent("Underline", ["svg", defaultAttributes, [["path", {
  d: "M6 4v6a6 6 0 0012 0V4",
  key: "1ktmln"
}], ["line", {
  x1: "4",
  y1: "20",
  x2: "20",
  y2: "20",
  key: "1iyt8l"
}]]]);
export default Underline;